import React, {PureComponent, useEffect, useRef, useState} from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import { AgendaUser, GetAgendaUserQuery, GetAgendaUserQueryVariables, ModelSortDirection, UsersByComIdQuery, UsersByComIdQueryVariables } from '../../graphql/API';
import { getAgendaUser, usersByComId } from './queries';
import { useLazyQuery, useQuery } from '@apollo/client';
import { Col, Row, Spinner, Stack } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import i18n from '../../contexts/I18n';
import { useTranslation } from 'react-i18next';
import Image from 'react-bootstrap/Image';
import UserImage from '../../components/UserImage';
import { Pagination } from '@aws-amplify/ui-react';
import { IoChatbox } from 'react-icons/io5';
import Sidebar from '../services/Sidebar/Sidebar';
import { FaUserTie } from 'react-icons/fa6';
import { ALLUSERS_PER_PAGE, USERS_PER_PAGE } from '../../config';
import Input from './Input';
import Cookies from 'js-cookie';

function capitalizeFirstLetter(word: string) {
  if (typeof word !== 'string' || word.length === 0) {
    return '';
  }
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

const UsersView = () => {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  // I18N
  const { t } = useTranslation();
  const savedLang = Cookies.get('language');
  const [locale, setLocale] = useState("en");
  // PAGINATION
  const [pageTokens, setPageTokens] = React.useState([null]);
  const [totalPagination, setTotalPagination] = React.useState(1);
  const [currentPageIndex, setCurrentPageIndex] = React.useState(1);
  const [hasMorePages, setHasMorePages] = React.useState(true);
  const [dontUpdateAnymore, setDontUpdateAnymore] = useState(false);
  const [usersState, setUsersState] = useState([]);
  // POSTS
  const [newUsers, setNewUsers] = useState<AgendaUser[]>([]);
  const [users, setUsers] = useState<AgendaUser[]>([]);
  const [nextToken, setNextToken] = useState('');
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const isRefreshingRef = useRef(false);
  // SEARCH
  const [newSearch, setNewSearch] = useState<string>();

  
  const {data: dataUser, loading, error, refetch, fetchMore} = useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
      {variables: {userId: AuthUserId}});

  const [fetchDataUsers, {data: dataUsers, loading: loadingUsers, error: errorUsers, 
      refetch: refetchUsers, fetchMore: fetchMoreUsers}] = useLazyQuery
      <UsersByComIdQuery, UsersByComIdQueryVariables>(usersByComId);

  const user = dataUser?.getAgendaUser;

  // const ITEMS_PER_PAGE = 25;

  useEffect(() => {
    document.title = t('title.users');
  }, []);

  const getUsers = async (token: string) => { //date: Date, 
    if (user?.comId) {
      return await fetchDataUsers({
        variables: {
          comId: user?.comId,  
          limit: USERS_PER_PAGE,               
          nextToken: token,  
          sortDirection: ModelSortDirection.ASC,
          filter: {
            suspended: {ne : true},
          }
          // sortDirection: ModelSortDirection.DESC,
        },
      });
    }
  }

  useEffect(() => {
    if (dataUser && !loading) {
      if (user?.comId) {
        getUsers(pageTokens[pageTokens.length - 1]);
      // fetchDataUsers({variables: {
      //   comId: user?.comId,
      //   // filter: { 
      //   //   stopAt: {lt: tomorrow},
      //   //   confirmed: {eq: true},
      //   //   suspended: {eq : false},
      //   //   deleted: {ne: true}}
      //   }});
      }
      // console.log("USERS ->", users);
    }
  }, [dataUser, loading]);

  useEffect(() => {
      if (!user || !user.comId || !newSearch || newSearch === "") return;
      if (newSearch === "***ALL***") {
          fetchDataUsers({
              variables: {
                  comId: user.comId,
                  sortDirection: ModelSortDirection.ASC,
                  limit: ALLUSERS_PER_PAGE,
                  filter: {
                      suspended: {ne: true},
                      username: {contains: newSearch === "***ALL***" ? "" : newSearch}
                  }
              },
          });
      } else {
          fetchDataUsers({
              variables: {
                  comId: user.comId,
                  sortDirection: ModelSortDirection.ASC,
                  limit: ALLUSERS_PER_PAGE,
                  filter: {
                      suspended: {ne: true},
                      or: [
                          { username: { contains: newSearch } },
                          { username: { contains: capitalizeFirstLetter(newSearch)} },
                          { username: { contains: newSearch.toLowerCase() } }, 
                          { username: { contains: newSearch.toUpperCase() } }, 
                      ]
                  }
              },
          });
      }
  }
  , [newSearch]);

  useEffect(() => {
      setUsers((dataUsers?.usersByComId?.items as AgendaUser[] || []));
      setNextToken(dataUsers?.usersByComId?.nextToken || '');
  }, [dataUsers]);

  useEffect(() => {
    const savedLang = Cookies.get('language');
    if (savedLang !== locale) {
      i18n.changeLanguage(savedLang);
      setLocale(savedLang);
    }
  }, [i18n, t]);
  
  // PAGINATIONS

  // useEffect(() => {
  //   if (dataUsers && dataUsers.usersByComId && !dontUpdateAnymore) {
  //     const newUsers = dataUsers.usersByComId.items;
  //     const newToken = dataUsers.usersByComId.nextToken;
 
  //     setUsersState(newUsers); // Met à jour la liste des utilisateurs
  //     if (newToken) {
  //       setPageTokens((prevTokens) => [...prevTokens, newToken]); // Ajoute un nouveau token
  //       setHasMorePages(true);
  //     } else {
  //       setHasMorePages(false); // Pas de token suivant, fin de la pagination
  //     }
  //   }
  // }, [dataUsers]);

  // useEffect(() => {
  //   if (hasMorePages) {
  //     setTotalPagination(pageTokens.length);
  //   } else {
  //     setTotalPagination(pageTokens.length - 1);
  //   }
  // },[hasMorePages]);

  // const handlePageChange = async (pageIndex: any) => {
  //   setDontUpdateAnymore(true);
  //   setCurrentPageIndex(pageIndex);

  //   const selectedToken = pageTokens[pageIndex - 1]; // Récupérer le token de la page sélectionnée
  //   if (selectedToken !== undefined) {
  //     const { data: { usersByComId: { items: newUsers, nextToken: newNextToken } } } = await getUsers(selectedToken);

  //     if (newUsers.length !== 0) {
  //       setUsersState(newUsers);
  //       USERS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
  //       if (newNextToken && !pageTokens.includes(newNextToken)) {
  //         setPageTokens((prevTokens) => [...prevTokens, newNextToken]);
  //       }
  //       // console.log(pageTokens);
  //     } else {
  //       if (hasMorePages) {
  //         setHasMorePages(false);
  //       }
  //     }
  //   }
  // };

  // const handleNextPage = async () => {
  //   setDontUpdateAnymore(true);
  //   // if (hasMorePages) {
  //     // const nextToken = pageTokens[pageTokens.length - 1]; // Dernier token actuel
  //     const nextToken = pageTokens[currentPageIndex];

  //     if (nextToken) {
  //       const { data: { usersByComId: { items: newUsers, nextToken: newNextToken } } } = await getUsers(nextToken);

  //       if (newNextToken) {
  //         setUsersState(newUsers);
  //         USERS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
  //         // console.log('allo');
  //         if (!pageTokens.includes(newNextToken)) {
  //             setPageTokens((prevTokens) => [...prevTokens, newNextToken]); // Ajoute le nouveau token
  //         }
  //         setCurrentPageIndex(currentPageIndex + 1);
  //       } else {
  //         if (newUsers.length > 0) {
  //           setUsersState(newUsers);
  //           USERS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
  //           setCurrentPageIndex(currentPageIndex + 1);
  //           // removeLastPagination();
  //           setHasMorePages(false);
  //         } else {
  //           if (hasMorePages) {
  //             // removeLastPagination();
  //             setHasMorePages(false);
  //           }
  //         }
  //         // setHasMorePages(false); // Si pas de nextToken, on désactive la pagination
  //       }
  //       // console.log(pageTokens);

  //       // setCurrentPageIndex(currentPageIndex + 1); // Mise à jour de l'index de la page
  //     } else {
  //       console.error("Next token is undefined or null");
  //     }
  //   // }
  // };

  // const handlePreviousPage = async () => {
  //   if (currentPageIndex > 1) {
  //     const prevToken = pageTokens[currentPageIndex - 2];
  //     const { data: { usersByComId: { items: prevUsers, nextToken: newNextToken } } } = await getUsers(prevToken);

  //     setUsersState(prevUsers);
  //     // setPageTokens(pageTokens.slice(0, -1)); 
  //     // if (hasMorePages) {
  //     //  setHasMorePages(nextToken ? true : false);
  //     // }
  //     USERS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
  //     setCurrentPageIndex(currentPageIndex - 1);
  //   }
  // };

  useEffect(() => {
      const timer = setTimeout(() => {
          setNewUsers([]);
      }, 1000 * 60 * 5); // 5 minutes
      
      return () => clearTimeout(timer);
  }, [newUsers]);

  const loadMore = async () => {
    if (!nextToken || isFetchingMore) {
        return;
    };
    setIsFetchingMore(true);
    const { data: moreData } = await fetchMoreUsers({
        variables: { nextToken },
        updateQuery: (previousQueryResult: any, { fetchMoreResult }: any) => {
          if (!fetchMoreResult) return previousQueryResult;
    
          setUsers(prevUsers => [
            ...prevUsers,
            ...fetchMoreResult.usersByComId.items,
          ]);

          setNextToken(fetchMoreResult.usersByComId.nextToken);
    
          return {
            ...previousQueryResult,
            usersByComId: {
              ...previousQueryResult.usersByComId,
              items: [
                ...previousQueryResult.usersByComId.items,
                ...fetchMoreResult.usersByComId.items,
              ],
              nextToken: fetchMoreResult.usersByComId.nextToken,
            },
          };
        },
    });
    setIsFetchingMore(false);
  };

  // PAGINATION
    useEffect(() => {
        const handleScroll = () => {
            const scrollable = document.documentElement.scrollHeight - window.innerHeight;
            const scrolled = window.scrollY;
            if (scrollable - scrolled < 5) {
                loadMore();
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [nextToken, isFetchingMore]);

    const refreshingUsers = () => {
        setNewUsers([]);
        refetchUsers();
    };

  // REFRESH BY SCROLLING
  useEffect(() => {
      window.scrollTo(0, 5);

      const handleScrollTop = () => {
          if (window.scrollY < 3 && !isRefreshingRef.current) {
              // console.log('Refreshing posts...');
              isRefreshingRef.current = true;
              refetchUsers();
              window.scrollTo(0, 5);

              setTimeout(() => {
                isRefreshingRef.current = false;
              }, 2000);
          }
      };

      window.addEventListener("scroll", handleScrollTop);

      return () => {
          window.removeEventListener("scroll", handleScrollTop);
      };
  }, [loading]);

  // const users = usersState;//dataUsers?.usersByComId?.items;
  // const users = dataUsers?.usersByComId?.items;

  // if (!loadingUsers) {
  if (!users) {
    // if (loading || loadingUsers || loadingShift) {
    // if (loading || loadingUsers || loadingShift || !users || !shifts) { // need to keep it like that to load all before the loading stop
    return (
        <div className="spinnerContainer">
            {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };

  const handleSearchSubmit = (newSearch: string) => {
      if (newSearch === "") {
          setNewSearch("***ALL***");
      } else {
          setNewSearch(newSearch);
      }
      console.log("Valeur soumise:", newSearch);
  };
  
  
  return (
    <div className="d-flex">
      <Sidebar user={user} />
      <div className="users-container flex-grow-1 p-3">
        <div className="users-container">
          <Stack direction="horizontal" gap={3} className="flex-wrap">
          { users.map((user) => (
            <>
              { user.userId !== AuthUserId &&
                <div
                  className="users_wrapper p-3 flex-fill bg-white border rounded-4 shadow-sm hover:shadow-md transition" // can remove flex-will
                  key={`user_${user.userId}`}
                >
                  <Link to={`/posts/${user.userId}`} className="usersPost_icon">
                    <IoChatbox size={24} title="Posts"/>
                  </Link>
                  { user.type === "MANAGER" && (
                    <FaUserTie className="users-manager" size={24} title="Manager"/>
                  )}
                  <Row className="g-3 align-items-center">
                    {/* Avatar */}
                    <Col xs={12} md={6} className="d-flex flex-column align-items-start flex-shrink-0 w-auto">
                      <Link to={`${t('link.user')}/${user.userId}`} className="text-decoration-none text-dark fw-bold link">
                        <UserImage user={user} customClass="coworker_md shadow-sm hover:shadow-md" key={"worker_" + user.userId} />
                      </Link>
                    </Col>

                    {/* Infos utilisateur */}
                    <Col className="ps-3">
                      <h5 className="mb-1">
                        <Link to={`${t('link.user')}/${user.userId}`} className="text-decoration-none text-dark fw-bold link">
                          {user.username}
                        </Link>
                      </h5>
                      <p className="text-muted mb-0">{user.email}</p>
                    </Col>
                  </Row>
                </div>
              }
            </>
          ))}
          </Stack>
          { user?.comId &&
              <Input comId={user.comId} locale={locale} onSubmit={handleSearchSubmit} userRole={user.role || "basic"}/>
          }

          {/* <div className="pagination-container">
            <h2 className="paginationTitle">{t('title.users')}</h2>
            
            <Pagination
              currentPage={currentPageIndex}
              totalPages={totalPagination}//{hasMorePages ? pageTokens.length: pageTokens.length - 1} //{Math.ceil(pageTokens.length / 10)} // Supposons que chaque page ait 10 éléments
              hasMorePages={hasMorePages}
              onNext={handleNextPage}
              // onPrevious={() => setCurrentPageIndex(currentPageIndex - 1)}
              onPrevious={handlePreviousPage}
              onChange={handlePageChange}
              // onChange={(pageIndex) => setCurrentPageIndex(pageIndex)}
              // showFirstLast
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default UsersView;


